<template>
    <div>
        <b-button variant="success" @click="attemptCheckout" v-bind="$attrs">
            <slot>{{ $t('buy') }}</slot>
        </b-button>
        <b-modal v-model="showBillingInformationModal" hide-cancel hide-ok>
            <BillingInfo @saved="billingInfoSave" v-if="!billingInfoSaved"/>
            <p v-else> {{ $t('yourBillingInfoIsSaved') }} </p>

            <template #modal-footer>
                <b-button variant="success" @click="goToCheckout(upgrade)" :disabled="!billingInfoSaved"> {{ $t('goToCheckout') }} </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Checkout from '@/lib/Checkout'
import BillingInfo from '@/views/users/BillingInfo'

export default {
    name: 'CheckoutButton',
    components: {
        BillingInfo,
    },
    props: {
        productType: {
            type: String
        },
        
        reference: {
            type: String
        },
        
        options: {
            type: Object
        },

        source: {
            type: String,
            default: 'platform'
        }
    },

    data: function() {
        return {
            showBillingInformationModal: false,
            billingInfoSaved: false,
        }
    },
    methods: {
        billingInfoSave() {
          this.billingInfoSaved = true
        },

        attemptCheckout() {
          // check is billing information filled in
          const { settings = {} } = this.$store.getters.getUser
          const { country } = settings.billing_address || {}

          console.log("checkout country", country)

          if (!country) {
            this.showBillingInformationModal = true
          } else {
            this.goToCheckout()
          }
        },

        async goToCheckout() {
            const popup = this.$loadingPopup()

            try {
                let checkout = new Checkout()
                const link = await checkout.getCheckoutLink({
                    product_type: this.productType,
                    reference: this.reference,
                    lang: this.$store.getters.getLocale,
                    options: this.options
                })

                window.open(link.data, '_blank')
            } catch (err) {
                if (err.response) {
                    if (err.response.status == 501) {
                        this.$bvToast.toast(this.$t('checkoutMethodCurrentlyDisabled'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                        return 
                    }
                }

                this.$bvToast.toast(this.$t('failedToCheckout'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })

                this.$debugLog(err)
            } finally {
                popup.hide()
            }

        }
    }
}
</script>